import {Component, ViewChild, OnInit, AfterViewInit, ElementRef} from '@angular/core';
import {Http} from '@angular/http';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';


declare let $: JQueryStatic | any;

import 'jquery-serializejson';
import 'jquery-validation';
import {DebtsModel} from '../../../models/debts/debts.model';
import {IClientModel} from '../../../models/clients/clients.model';


@Component({
    selector: 'invoice-modal',
    templateUrl: 'invoice-modal.template.html',
    styleUrls: []
})

export class InvoiceModalComponent implements OnInit, AfterViewInit {

    public debt = new DebtsModel();
    public client = <IClientModel> {};
    public clientId: number;


    constructor(
        private route: ActivatedRoute,
        public activeModal: NgbActiveModal
    ) {



    }

    ngOnInit() {



    }

    ngAfterViewInit() {

    }


    // ===========================================================
    // Functions
    // ===========================================================


    loadData() {



    }


    // ===========================================================
    // Actions
    // ===========================================================



    public setFunded() {

    }


    public close() {

    }

    public applyTopup() {

    }
}


// WEBPACK FOOTER //
// ./src/app/modules/debt-account/invoice-modal/invoice-modal.component.ts